import styled, { css } from "styled-components"

export const Container = styled.div`
  ${getErrorColors}
`

function getErrorColors({ theme }) {
  const {
    colors: {
      alert: { fg, bg },
    },
    fonts,
    spaces: { small },
  } = theme

  return css`
    color: ${bg};
    background-color: ${fg};
    font-weight: ${fonts.weight.bold};
    margin-top: ${small};
    margin-bottom: ${small};
  `
}
